import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import { useToast } from 'vuestic-ui'

// import stores from './stores'
import store from './store/'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
import { getSessionManager } from './utils/sessionManager'

const app = createApp(App)

app.use(store)
app.use(i18n)
// Vuestic before the router: the first navigation (refresh) runs beforeEach and
// may toast. Installing the router first is what let a stale-cookie 401 crush boot.
app.use(createVuestic({ config: vuesticGlobalConfig }))

window.addEventListener('session-conflict', ((event: CustomEvent) => {
  try {
    useToast().init({
      message:
        event.detail.message ||
        'You are already logged in another tab. Please close this tab or use the existing session.',
      color: 'warning',
      duration: 5000,
    })
  } catch {
    // Ignore if a conflict fires before the toast plugin is usable.
  }
  // Do not router.push here — that races the auth guard and freezes navigation.
}) as EventListener)

// After the listener so a conflict during construction is not dropped.
getSessionManager()

app.use(router)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
